import { Modal } from '@mantine/core'
import { ReactNode, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import { NestedModalContext } from '@/components/ui-shared/NestedModal/NestedModalContext'

type VlmPipelineCreateModalProps = {
  opened: boolean
  isEditing?: boolean
  onClose: () => void
  children: ReactNode
}

export const VlmPipelineCreateModal = ({
  opened,
  isEditing,
  onClose,
  children
}: VlmPipelineCreateModalProps) => {
  const [hasNestedModal, setHasNestedModal] = useState(false)

  return (
    <NestedModalContext.Provider value={setHasNestedModal}>
      <Modal
        size="60rem"
        title={
          <FormattedMessage
            id={
              isEditing
                ? 'vlm.pipelines.edit.title'
                : 'vlm.pipelines.create.title'
            }
          />
        }
        opened={opened}
        closeOnEscape={!hasNestedModal}
        closeOnClickOutside={false}
        onClose={onClose}
      >
        {children}
      </Modal>
    </NestedModalContext.Provider>
  )
}
